import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { MAIN_CONTENT_ID, useFocusOnChange } from '@munifocus/ui';

// React Router preserves scroll position across navigations, which lands you
// mid-page when following a link from lower down a list. Reset to the top on each
// pathname change — but defer to in-page anchors (e.g. #subscribe) when a hash is
// present so those still scroll to their target.
//
// Scrolling alone is not enough for a keyboard or screen-reader user: focus stays
// on the (now unmounted) link and falls back to `<body>`, so the next Tab restarts
// from the site header on every navigation. Move focus to `<main>` as well
// (WCAG 2.4.3), which also makes the new page's content the next thing announced.
export function ScrollToTop() {
  const { pathname, hash } = useLocation();

  useFocusOnChange(hash ? `${pathname}${hash}` : pathname, MAIN_CONTENT_ID);

  useEffect(() => {
    if (hash) return;
    window.scrollTo(0, 0);
  }, [pathname, hash]);

  return null;
}
